import omit from 'lodash/omit';

// taken from https://github.com/marmelab/react-admin/blob/master/packages/ra-ui-materialui/src/field/sanitizeRestProps.ts
const sanitizeRestProps = (props) =>
    omit(props, [
        'addLabel',
        'allowEmpty',
        'basePath',
        'cellClassName',
        'className',
        'formClassName',
        'headerClassName',
        'label',
        'linkType',
        'locale',
        'record',
        'resource',
        'sortable',
        'sortBy',
        'source',
        'textAlign',
        'translateChoice',
	]);

export default sanitizeRestProps;
